import {IPriceCitiesSummary} from "./get_cities_data";

export const calculateGeneralAvgPrices = (citiesData?: IPriceCitiesSummary[]) => {
    let allOffers = 0;
    let allOffersOld = 0;
    let generalAvgPrice = 0;
    let generalAvgM2Price = 0;
    let generalAvgPriceOld = 0;
    let generalAvgM2PriceOld = 0;

    if (citiesData) {
        allOffers = citiesData.reduce((acc, curr) => (acc += curr.availableOffers), 0);
        allOffersOld = citiesData.reduce((acc, curr) => (acc += curr.oldAvailableOffers), 0);
        generalAvgPrice = citiesData.reduce((acc, curr) => (acc += curr.avgPrice * curr.availableOffers), 0) / allOffers;
        generalAvgM2Price = citiesData.reduce((acc, curr) => (acc += curr.avgPriceM2 * curr.availableOffers), 0) / allOffers;
        generalAvgPriceOld = citiesData.reduce((acc, curr) => (acc += curr.oldAvgPrice * curr.oldAvailableOffers), 0) / allOffersOld;
        generalAvgM2PriceOld = citiesData.reduce((acc, curr) => (acc += curr.oldAvgPriceM2 * curr.oldAvailableOffers), 0) / allOffersOld;
    }

    return {
        allOffers,
        allOffersOld,
        generalAvgPrice,
        generalAvgM2Price,
        generalAvgPriceOld,
        generalAvgM2PriceOld
    };
};
import {IPriceCitiesSummary} from "./get_cities_data";

export const calculateGeneralAvgPrices = (citiesData?: IPriceCitiesSummary[]) => {
    let allOffers = 0;
    let allOffersOld = 0;
    let generalAvgPrice = 0;
    let generalAvgM2Price = 0;
    let generalAvgPriceOld = 0;
    let generalAvgM2PriceOld = 0;

    if (citiesData) {
        allOffers = citiesData.reduce((acc, curr) => (acc += curr.availableOffers), 0);
        allOffersOld = citiesData.reduce((acc, curr) => (acc += curr.oldAvailableOffers), 0);
        generalAvgPrice = citiesData.reduce((acc, curr) => (acc += curr.avgPrice * curr.availableOffers), 0) / allOffers;
        generalAvgM2Price = citiesData.reduce((acc, curr) => (acc += curr.avgPriceM2 * curr.availableOffers), 0) / allOffers;
        generalAvgPriceOld = citiesData.reduce((acc, curr) => (acc += curr.oldAvgPrice * curr.oldAvailableOffers), 0) / allOffersOld;
        generalAvgM2PriceOld = citiesData.reduce((acc, curr) => (acc += curr.oldAvgPriceM2 * curr.oldAvailableOffers), 0) / allOffersOld;
    }

    return {
        allOffers,
        allOffersOld,
        generalAvgPrice,
        generalAvgM2Price,
        generalAvgPriceOld,
        generalAvgM2PriceOld
    };
};
